export type TSourceRefreshDateTime = {
  perspectiveName: string;
  fiscalYear: number;
  sourceName?: string;
  lastRefreshTime: string;
  nextRefreshTime?: string;
};

export type TAppConfig = {
  defaultFiscalYearId: string;
  defaultSemesterId: string;
  flightedPlans: string[];
  isBusinessPersona: boolean;
  businessPersonaRoleName?: ERoleNames;
  moduleRefreshDateTimes?: {
    Plan_Setup_Pipeline?: string | null | undefined;
    Participant_Pipeline?: string | null | undefined;
    Compliance_Pipeline?: string | null | undefined;
    Payout_Pipeline?: string | null | undefined;
    DLTR_Pipeline?: string | null | undefined;
    DLTR_High_Data_Write_Pipeline?: string | null | undefined;
    DLTR_Low_Data_Write_Pipeline?: string | null | undefined;
  };
  sourceRefreshDateTimes?: { [key: string]: TSourceRefreshDateTime[] };
};

export enum ERoleNames {
  OperationsSupport = 'Operations.Support',
  BusinessAdmin = 'Business.Admin',
  None = 'None',
}
